

function animateSections() {
  $('.section').each(function(index) {
    animateIntroSection(this);
    updateNavigation(this);
  });
}

function updateNavigation(section) {
  var $this = $(section);
  var dataSection = $this.data('section');
  var dataChapter = $this.data('chapter');

  var scene = new ScrollMagic.Scene({
    triggerElement: section,
    triggerHook: 0.5,
    offset: 0
  })
  .on('enter', function (event) {
    $('.navigation .nav-item').removeClass('active');
    $('.navigation .nav-item[data-section="' + dataSection + '"]').addClass( "active" );
  })
  .on('leave', function (event) {
    $('.navigation .nav-item[data-section="' + dataSection + '"]').prev().addClass('active');
    $('.navigation .nav-item[data-section="' + dataSection + '"]').removeClass('active');
  })
  .addTo(controller);

}

function animateIntroSection(section) {
  var $this = $(section);

  var $aSlowMo = CustomEase.create("custom", "M0,0 C0,0 0.224,0.62 0.316,0.792 0.444,1.031 1,1 1,1");

  var $introImage       = $this.find(".bg-image"),
  $introParticles       = $this.find(".bg-particles"),
  $sectionTitle         = $this.find('.section-intro').find('h2'),
  $sectionTitleLine     = $this.find('.section-intro').find('.title-line'),
  $sectionIntroContent  = $this.find('.section-intro').find('.section-intro-content'),
  introSplitText        = new SplitText($sectionTitle, {type:"words"});

  var introTL      = new TimelineLite({paused: true});
  var introTextTL  = new TimelineLite({paused: true});

  TweenMax.set($introImage, {y: 0, transformOrigin: "bottom"});
  TweenMax.set($sectionTitleLine, {scale: 0, transformOrigin: "left"});
  TweenMax.set($sectionIntroContent, {y: -20, opacity: 0});
  TweenMax.set(introSplitText, {perspective:400});

  introTL.to($sectionTitleLine, 1, { scale: 1, ease: $aSlowMo }, 0.75)
  .to($sectionIntroContent, 0.5, { y: 0, opacity: 1, ease: Power4.easeOut }, 0.75);

  introSplitText.split({type:"words"});

  $(introSplitText.words).each(function(index,el){
    introTextTL.from($(el), 0.5, {opacity:0, force3D:true}, index * 0.2);
    introTextTL.from($(el), 0.5, {scale: 1.1, ease:Power1.easeOut}, index * 0.2);
  });

  var scene = new ScrollMagic.Scene({
    triggerElement: section,
    triggerHook: 0.8,
    offset: 0
  })
  .on('enter', function (event) {
    introTL.play().timeScale(1);
    introTextTL.play().timeScale(1.5);
  })
  .on('leave', function (event) {
    introTL.reverse().timeScale(1.5);
    introTextTL.reverse().timeScale(1.5);
  })
  .addTo(controller);

  new ScrollMagic.Scene({triggerElement: section, offset: 0, duration: "100%"})
  .setTween($introImage, {y: -50, ease: Linear.easeNone})
  .addTo(controller);

  new ScrollMagic.Scene({triggerElement: section, offset: 0, duration: "100%"})
  .setTween($introParticles, {yPercent: -50, ease: Linear.easeNone})
  .addTo(controller);
}